import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { I18nService } from '@digilize/shared/feature/modules/i18n/src/lib/i18n.service';
import { Subject, takeUntil } from 'rxjs';

import { ClarityService } from '../application/services/clarity.service';
import { FaviconService } from '../application/services/favicon.service';
import { ShopSessionService } from '../application/services/shop-session.service';
import { AuthState } from '../auth/application/auth.state';
import { ThemeService } from '../ui/theme/theme.service';

@Component({
  selector: 'plys-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  destroy$ = new Subject<void>();

  constructor(
    private themeService: ThemeService,
    @Inject(DOCUMENT) private dom: Document,
    private i18nService: I18nService,
    private authState: AuthState,
    private clarityService: ClarityService,
    private shopSessionService: ShopSessionService,
    private faviconService: FaviconService
  ) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    /* The `lang` record is shared with the portal (`/user/`) and order2seat (`/order2seat/`), which
       run on this origin and do have a language switcher; the webshop has none, so a choice made
       there used to outrank the buyer's browser here for good (PAUL-3519). */
    this.i18nService.init({ useStoredLang: false });
    this.clarityService.init();
    this.shopSessionService.init();
    this.faviconService.init();
    this.themeService.theme$.pipe(takeUntil(this.destroy$)).subscribe((theme) => {
      if (theme === 'light') {
        this.dom.documentElement.classList.add('light-theme');
      }
    });
    this.authState.getUser().subscribe((user) => {
      this.authState.setUser(user);
    });
  }
}
